import axios from "axios";

export default axios.create({
    baseURL:"https://kickstarterapi.herokuapp.com/"
}) 